var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72506 4.12503H11.4376C11.679 4.12503 11.8923 4.27737 11.9696 4.50472C12.047 4.73206 11.972 4.98285 11.7821 5.1305L8.71647 7.51646L9.91179 11.2665C9.98679 11.5009 9.90007 11.7587 9.69616 11.8993C9.4946 12.0399 9.22507 12.0329 9.03053 11.8805L6.00004 9.52506L2.96955 11.8805C2.77502 12.0329 2.50549 12.0399 2.30322 11.8993C2.10119 11.7587 2.01424 11.5009 2.089 11.2665L3.28362 7.51646L0.217201 5.1305C0.0275197 4.98285 -0.0475043 4.73206 0.0304728 4.50472C0.108473 4.27737 0.322272 4.12503 0.562508 4.12503H4.27738L5.46332 0.391878C5.53832 0.158532 5.75629 0 6.00004 0C6.24614 0 6.46177 0.158532 6.53677 0.391878L7.72506 4.12503Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dba5ddbf9a60afda61bbc3d82b7d1523.svg";
export { ForwardRef as ReactComponent };